import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { LOGO } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] px-6">
      <div className="pc-glow w-[400px] h-[400px] top-0 left-1/2 -translate-x-1/2" />
      <div className="relative w-full max-w-sm rounded-2xl border border-white/10 bg-[#121212] p-8">
        <img src={LOGO} alt="The Pink Crew" className="h-14 w-auto rounded-md mx-auto mb-6" />
        <div className="flex items-center gap-2 justify-center text-pink-500 mb-6"><Lock size={18} /><span className="text-sm uppercase tracking-widest font-bold">Control Console</span></div>
        <form onSubmit={submit} className="space-y-4">
          <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" type="email" autoCapitalize="none" autoCorrect="off" spellCheck={false} className="w-full bg-[#050505] border border-white/20 focus:border-pink-500 rounded-lg px-4 py-3 outline-none" data-testid="admin-email" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" autoCapitalize="none" autoCorrect="off" spellCheck={false} className="w-full bg-[#050505] border border-white/20 focus:border-pink-500 rounded-lg px-4 py-3 outline-none" data-testid="admin-password" />
          <button disabled={loading} className="w-full bg-pink-600 hover:bg-pink-500 rounded-full py-3 font-semibold transition-colors active:scale-95 disabled:opacity-50" data-testid="admin-login-btn">{loading ? "Signing in…" : "Sign In"}</button>
        </form>
      </div>
    </div>
  );
}
